import React, { memo, FC } from 'react'
import styles from './style.module.css'

type Props = {
  isOpen: boolean
  message: string
  onClose: () => void
}

const ErrorModal: FC<Props> = ({ isOpen, message, onClose }) => {
  if (!isOpen) return null

  return (
    <div className={styles.backdrop}>
      <div className={styles.modalDialog}>
        <div className={styles.modalContent}>
          <div className={styles.modalBody}>{message}</div>
          <div className={styles.modalFooter}>
            <button type="button" className={styles.button} onClick={onClose}>
              とじる
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default memo(ErrorModal)
